export var SyncModelDirective = [
    function () {
        return {
            link: function ($scope, $element, $attributes, _$controller) {
                var $controller = _$controller;
                var newVal = $element.val() || $element.html();
                if ($controller.$pristine && $controller.$viewValue !== newVal && newVal) {
                    $controller.$setViewValue(newVal);
                }
            },
            require: 'ngModel',
            restrict: 'A',
        };
    },
];
